

function renderValidatorResult(report,target){
    try {
        // console.info('Validation report', report)

        //Translate each report.messages element to friendly version
        report.messages.forEach(function(element,index) {
            //console.log(element);
            var key = element.name.toUpperCase();
            if( validatorFriendlyMessages[key] != undefined ){
                report.messages[index].result = validatorFriendlyMessages[key];
            }
            report.messages[index].name = key.split("_").join(" ").toProperCase();
        });


        var hbstemplate = mantlhbs.validator.report;
        var output = hbstemplate(report);
        $(target).html(output);

        if(report.valid){
            alertify.success('Badge Validated');
        } else {
            alertify.warning('Badge Does Not Appear to Be Valid');
        }
    }
    catch (e) {
        console.error('Error rendering validator report.', e);
    }
}

function getValidatorResultHTML(report){
    try {
        // console.info('Validation report', report)
        //Translate each report.messages element to friendly version
        report.messages.forEach(function(element,index) {
            //console.log(element);
            var key = element.name.toUpperCase();
            if( validatorFriendlyMessages[key] != undefined ){
                report.messages[index].result = validatorFriendlyMessages[key];
            }
            report.messages[index].name = key.split("_").join(" ").toProperCase();
        });

        var hbstemplate = mantlhbs.validator.report;
        var output = hbstemplate(report);
        return output;
    }
    catch (e) {
        console.error('Error rendering validator report.', e);
        return "<p>Error getting validator report.</p>"
    }
}

var validatorFriendlyMessages = {
    ASSERTION_TIMESTAMP_CHECKS:                "This assertion has expired or has an awarded date from the future.",
    ASSERTION_VERIFICATION_DEPENDENCIES:       "There was an issue verifying the hosted assertion's dependencies.",
    DETECT_AND_VALIDATE_NODE_CLASS:            "detect_and_validate_node_class",
    CRITERIA_PROPERTY_DEPENDENCIES:            "There is an issue with the badge crtieria link or narrative.",
    IDENTITY_OBJECT_PROPERTY_DEPENDENCIES:     "There is an issue with the email format or identity hash.",
    ISSUER_PROPERTY_DEPENDENCIES:              "There was a problem retrieving the Issuer profile.",
    VALIDATE_REVOCATIONLIST_ENTRIES:           "There was a problem reading the Issuer's Revocation List.",
    VERIFY_RECIPIENT_IDENTIFIER:               "We could not match the earner of this badge to the user.",
    VERIFY_SIGNED_ASSERTION_NOT_REVOKED:       "Bade appears to be revoked.",
    IMAGE_VALIDATION:                          "Badge image is not valid."
}
